import axios from "axios";
import { HTTP_STATUS, baseURL } from "shared/constants/AppConst";

const jwtAxios = axios.create({
    baseURL: baseURL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
    },
});
jwtAxios.interceptors.response.use(
    (res) => res,
    (err) => {
        if (
            err.response &&
            err.response.data.status == HTTP_STATUS[500] &&
            err.response.data.message === "TOKEN_ISSUE"
        ) {
            localStorage.clear();
            setTimeout(() => {
                window.location.reload(false);
            }, 1000);
        }
        return Promise.reject(err);
    }
);
export const setAuthToken = (token) => {
    if (token) {
        jwtAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
        localStorage.setItem("token", token);
    } else {
        delete jwtAxios.defaults.headers.common["Authorization"];
        localStorage.removeItem("token");
    }
};

export default jwtAxios;
